import { Card, CardContent, Typography, Stack } from '@mui/material'
import { FunctionField, ReferenceField } from 'react-admin'
import { formatDisplayDate } from '../../../utils/helpers'

const DEFAULT_PROVIDER_ID = '00000000-0000-0000-0000-000000000000'

const Row = ({ label, value }) => (
  <Stack>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1">{value ?? '—'}</Typography>
  </Stack>
)

const ProviderDisplay = ({ record }) => {
  if (!record) {
    return <Row label="Provider" value="—" />
  }

  if ((!record.providerId || record.providerId === DEFAULT_PROVIDER_ID) && record.providerNameOther) {
    return <Row label="Provider" value={record.providerNameOther} />
  }

  return (
    <Stack>
      <Typography variant="body2" color="text.secondary">
        Provider
      </Typography>
      <ReferenceField source="providerId" reference="provider-portal/providers" record={record} link={false}>
        <FunctionField
          render={(provider) => provider?.displayName || record?.providerName || record?.providerNameOther || '—'}
        />
      </ReferenceField>
    </Stack>
  )
}

const PatientCard = ({ record }) => (
  <Card>
    <CardContent>
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
        Patient
      </Typography>
      <Stack spacing={1.5}>
        <Row label="Patient Name" value={record?.patientName} />
        <Row label="Date of Birth" value={formatDisplayDate(record?.patientDoB)} />
        <Row label="Date of Vasectomy" value={formatDisplayDate(record?.patientDoV)} />
        <ProviderDisplay record={record} />
      </Stack>
    </CardContent>
  </Card>
)

export default PatientCard
